"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeChannel = void 0;
const action_1 = require("../../action");
const topic_1 = require("../../topic");
const NATIVE_CHANNEL = 'native';
class NativeChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = NATIVE_CHANNEL;
        this.topics = {
            TouchIdPostLoginFlow: new topic_1.Topic('TouchIdPostLoginFlow', NATIVE_CHANNEL, this._logger),
            ResetTouchId: new topic_1.Topic('ResetTouchId', NATIVE_CHANNEL, this._logger),
            SaveTouchIdToken: new topic_1.Topic('SaveTouchIdToken', NATIVE_CHANNEL, this._logger),
            SaveSuggestedStatus: new topic_1.Topic('SaveSuggestedStatus', NATIVE_CHANNEL, this._logger),
            navigationReady: new topic_1.Topic('navigationReady', NATIVE_CHANNEL, this._logger),
            userIsFitToPlay: new topic_1.Topic('userIsFitToPlay', NATIVE_CHANNEL, this._logger),
            isTouchIdEnabled: new topic_1.Topic('isTouchIdEnabled', NATIVE_CHANNEL, this._logger),
            checkTouchIdEnabled: new topic_1.Topic('checkTouchIdEnabled', NATIVE_CHANNEL, this._logger),
            isFirstTouchLogin: new topic_1.Topic('isFirstTouchLogin', NATIVE_CHANNEL, this._logger),
            nativeInit: new topic_1.Topic('nativeInit', NATIVE_CHANNEL, this._logger),
            themeModeUpdate: new topic_1.Topic('themeModeUpdate', NATIVE_CHANNEL, this._logger),
            getInfoRequest: new action_1.Action('getInfoRequest', NATIVE_CHANNEL, this._logger),
            triggerAppRating: new topic_1.Topic('triggerAppRating', NATIVE_CHANNEL, this._logger),
            updateAppLifecycleStatus: new topic_1.Topic('updateAppLifecycleStatus', NATIVE_CHANNEL, this._logger),
            setMfaCode: new topic_1.Topic('setMfaCode', NATIVE_CHANNEL, this._logger),
            getPermissionRequest: new action_1.Action('getPermissionRequest', NATIVE_CHANNEL, this._logger),
        };
    }
}
exports.NativeChannel = NativeChannel;
//# sourceMappingURL=native.channel.js.map